"use strict";

var _preact = require("preact");
var classNames = require("classnames");
var ignoreEvent = require("../utils/ignoreEvent.js");
function PickerPanelContent(_ref) {
  var activePickerPanel = _ref.activePickerPanel,
    className = _ref.className,
    hideAllPanels = _ref.hideAllPanels,
    i18n = _ref.i18n,
    state = _ref.state,
    uppy = _ref.uppy;
  return (0, _preact.h)("div", {
    className: classNames('uppy-DashboardContent-panel', className),
    role: "tabpanel",
    "data-uppy-panelType": "PickerPanel",
    id: "uppy-DashboardContent-panel--".concat(activePickerPanel.id),
    onDragOver: ignoreEvent,
    onDragLeave: ignoreEvent,
    onDrop: ignoreEvent,
    onPaste: ignoreEvent
  }, (0, _preact.h)("div", {
    className: "uppy-DashboardContent-bar"
  }, (0, _preact.h)("div", {
    className: "uppy-DashboardContent-title",
    role: "heading",
    "aria-level": "1"
  }, i18n('importFrom', {
    name: activePickerPanel.name
  })), (0, _preact.h)("button", {
    className: "uppy-DashboardContent-back",
    type: "button",
    onClick: hideAllPanels
  }, i18n('cancel'))), (0, _preact.h)("div", {
    className: "uppy-DashboardContent-panelBody"
  }, uppy.getPlugin(activePickerPanel.id).render(state)));
}
module.exports = PickerPanelContent;